import React, { useState, useEffect, useMemo } from 'react'
import Card from 'react-bootstrap/Card';
import ReactDataTableBootstrap from '../../Components/ReactDataTableBootstrap/ReactDataTableBootstrap';
import Controllers from '../../Api/Controllers';
import Helpers from '../../Components/Helpers/Helpers';
import { toast } from 'react-toastify'

const HistoryCommisions = _ => {
    const [isProcessing, setIsProccesing] = useState(false)
    const [rows, setRows] = useState({
        total: 0,
        details: [],
        code_money: ''
    })

    useEffect(() => {
        setIsProccesing(true)
        Controllers.report.get_report_commissions_period_by_customers().then(res => {
            setRows(res.data)
        }).catch(req => Helpers.promise.catch({ req, toast }))
            .finally(() => {
                setIsProccesing(false)
            })
    }, [])

    const dtRows = useMemo(() => <ReactDataTableBootstrap
        head={[
            [
                { name: 'name_period', text: 'Periódo', sort: false, align: 'center' },
                { name: 'name_plan', text: 'Rango', sort: false, align: 'center' },
                { name: 'subtotal_earnings', text: 'Ganancia', align: 'center', sort: false, render: r => '$ ' + r.subtotal_earnings },
                { name: 'isr', text: 'ISR', align: 'center', sort: false, render: r => '$ ' + r.isr },
                { name: 'total', text: 'Total', align: 'center', sort: false, render: r => '$ ' + r.total },
                { name: 'code_money', text: 'Moneda', align: 'center', sort: false },
            ],
        ]}
        rows={rows.details}
        pageLength={100}
        isProcessing={isProcessing}
        noSort
    />, [rows, isProcessing])

    return <div className="ui-page">
        <div className="ui-page-head">
            <div>
                <h1 className="ui-page-title">Historial de Comisiones</h1>
                <p className="ui-page-meta">Resumen por período</p>
            </div>
        </div>
        {!isProcessing ? <div className="ui-summary-strip">
            <Card className="ui-metric-card is-primary mb-0">
                <Card.Body className="text-center py-3">
                    <span className="ui-metric-label">Total comisiones</span>
                    <div className="ui-metric-value" style={{ fontSize: '1.1rem' }}>
                        {rows.code_money} {rows.total}
                    </div>
                </Card.Body>
            </Card>
            <Card className="ui-metric-card mb-0">
                <Card.Body className="text-center py-3">
                    <span className="ui-metric-label">Períodos</span>
                    <div className="ui-metric-value">{rows.details?.length || 0}</div>
                </Card.Body>
            </Card>
        </div> : null}
        <Card className="ui-list-shell border-0">
            <Card.Header>
                <span>Detalle</span>
            </Card.Header>
            <Card.Body>
                {dtRows}
            </Card.Body>
        </Card>
        {isProcessing ? '' : <div className="ui-totals-panel">
            <div className="ui-totals-row is-total" style={{ borderTop: 'none', marginTop: 0, paddingTop: 0 }}>
                <span>Total de Comisiones</span>
                <span>{rows.code_money} {rows.total}</span>
            </div>
        </div>}
    </div>
}

export default HistoryCommisions
